export const parsePlanoManutencaoItemIndex = (item) => {
  const rawIndex =
    item?.index !== undefined && item?.index !== null ? item.index : item?.Index;
  if (typeof rawIndex === "string" && rawIndex.trim() === "") {
    return null;
  }

  const parsedIndex = Number(rawIndex);

  return Number.isFinite(parsedIndex) ? parsedIndex : null;
};

export const ordenarItensPlanoManutencao = (itens) => {
  return (Array.isArray(itens) ? itens : [])
    .map((item, originalPosition) => ({
      ...item,
      index: parsePlanoManutencaoItemIndex(item),
      __originalPosition: originalPosition,
    }))
    .sort((a, b) => {
      const aHasIndex = Number.isFinite(a.index);
      const bHasIndex = Number.isFinite(b.index);

      if (aHasIndex && bHasIndex && a.index !== b.index) {
        return a.index - b.index;
      }

      if (aHasIndex !== bHasIndex) {
        return aHasIndex ? -1 : 1;
      }

      return a.__originalPosition - b.__originalPosition;
    })
    .map((item) => {
      const itemNormalizado = { ...item };
      delete itemNormalizado.__originalPosition;
      return itemNormalizado;
    });
};

export const reindexarItensPlanoManutencao = (itens) => {
  return (Array.isArray(itens) ? itens : []).map((item, index) => ({
    ...item,
    index,
  }));
};